import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';
import { Dayjs } from 'dayjs';

import { IndividualSelect } from '@/pages/Pathology/components/acts/IndividualSelect';
import { audioSourceSchema } from '@/pages/Pathology/components/common/audioSource.config';
import { UUID } from '@/shared/api/types';
import { AutopsySource } from '@/shared/pathology/enums';
import DateMapper from '@/utils/dateUtils';

export const addSchema = (organizationId?: UUID): IFormItem[] => [
  {
    label: 'Особь',
    key: 'individualId',
    type: 'custom',
    payload: {
      component: IndividualSelect,
      props: {
        organizationId,
        placeholder: 'Начните вводить инвентарный номер',
      },
    },
    validation: [Validators.required('Выберите особь')],
  },
  {
    label: 'Дата вскрытия',
    placeholder: 'Выберите дату',
    key: 'performedAt',
    type: 'date',
    payload: {
      disabledDate: (current: Dayjs) => current && current > DateMapper().endOf('day'),
    },
    validation: [Validators.required()],
  },
  {
    label: 'Примечание',
    placeholder: 'Введите примечание',
    key: 'notes',
    type: 'textarea',
    payload: {
      autoSize: { minRows: 2, maxRows: 6 },
    },
  },
  ...audioSourceSchema([AutopsySource.UPLOAD, AutopsySource.RECORD, AutopsySource.TEXT]),
];
